import styled from 'styled-components';

// Mobile Header Components
export const MobileHeader = styled.div<{ $textVisible: boolean }>`
  display: none;
  
  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
    background: rgba(240, 240, 240, 0.4);
    border: 2px solid rgba(180, 180, 180, 0.4);
    border-radius: ${props => props.$textVisible ? '15px 15px 0 0' : '15px'};
    backdrop-filter: blur(25px);
    box-shadow: ${props => props.$textVisible ? 'none' : '0 4px 20px rgba(0, 0, 0, 0.15)'};
    margin: 10px;
    z-index: 100;
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
  }
`;

export const MobileLogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const MobileTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const MobileTitleMain = styled.h1`
  color: #000000;
  font-size: 18px;
  font-weight: 700;
  margin: 0;
`;

export const MobileTitleSub = styled.p`
  color: #000000;
  font-size: 14px;
  font-weight: 700;
  margin: 0;
`;

export const SkyLogoImg = styled.img`
  width: 60px;
  height: 60px;
  object-fit: contain;
  background: transparent;
`;

export const MobileHeaderButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

// Mobile responsive overrides for existing components
export const mobileStyles = {
  HeaderOverlay: `
    @media (max-width: 768px) {
      position: absolute;
      top: 100px;
      left: 10px;
      right: 10px;
      width: auto;
      margin: 0 10px;
      display: \${props => props.$isVisible ? 'flex' : 'none'};
    }
  `,
  
  HeaderBox: `
    @media (max-width: 768px) {
      display: none;
    }
  `,
  
  LogoContainer: `
    @media (max-width: 768px) {
      display: none;
    }
  `,
  
  ResponseOverlay: `
    @media (max-width: 768px) {
      width: 100%;
      max-height: calc(100vh - 300px);
      margin-bottom: 20px;
      margin-top: 0;
    }
  `,
  
  ResponseBox: `
    @media (max-width: 768px) {
      padding: 15px;
      border-radius: 0 0 10px 10px;
    }
  `,
  
  TopRightContainer: `
    @media (max-width: 768px) {
      top: 10px;
      right: 10px;
      flex-direction: column;
      gap: 5px;
      
      button:last-child {
        display: none;
      }
    }
  `,
  
  DateTimeContainer: `
    @media (max-width: 768px) {
      display: none;
    }
  `,
  
  NMPLogoImg: `
    @media (max-width: 768px) {
      width: 60px;
      height: 60px;
    }
  `,
  
  HeaderTitle: `
    @media (max-width: 768px) {
      font-size: 18px;
    }
  `,
  
  HeaderSubtitle: `
    @media (max-width: 768px) {
      font-size: 12px;
    }
  `,
  
  HeaderSubtitle2: `
    @media (max-width: 768px) {
      font-size: 14px;
    }
  `,
  
  ResponseText: `
    @media (max-width: 768px) {
      font-size: 14px;
    }
  `,
  
  ControlButton: `
    @media (max-width: 768px) {
      width: 60px;
      height: 60px;
      
      svg {
        width: 24px;
        height: 24px;
      }
    }
  `,
  
  ButtonContainer: `
    @media (max-width: 768px) {
      gap: 15px;
    }
  `,
  
  ToggleTextButton: `
    @media (max-width: 768px) {
      display: flex;
      width: 60px;
      height: 60px;
    }
  `,
  
  TextInputContainer: `
    @media (max-width: 768px) {
      padding: 20px;
      width: 95%;
      margin: 0 10px;
    }
  `,
  
  ScrollableContent: `
    @media (max-width: 768px) {
      max-height: calc(100vh - 350px);
    }
  `
};
